<template>
  <el-form-item ref="formItem" class="sky-url-link">
    <el-button type="text" @click="openUrl">
      云桌面版本更新功能速查表
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Button } from 'element-ui'

export default {
  name: 'SkyUrlLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    openUrl() {
      window.open('https://ruijie.feishu.cn/sheets/shtcns1v4iDZrCmMuOFnnY0okIf?sheet=9822ac', '_blank')
    }
  }
}
</script>
